import axios from "axios"
import { ProductAddToCart } from "src/types"

/**
 *
 * @param data
 * @returns {Promise}
 */
function callCartEndpoint(data: object) {
  return axios.post("/cart/add.js", data)
}

/**
 * Wrapper function for Shopify's cart API to add a single item to the shopping cart.
 * The identifier specified is the identifier of the actual variant and not of the
 * parent product. This allows SKUs in Nosto recommendations to be added to the
 * cart directly.
 *
 * @see {@link https://help.shopify.com/themes/development/getting-started/using-ajax-api}
 * @param {string} variantId - the identifier of the variant to add to the cart
 * @param {Integer} quantity - the quantity to be added (or 1)
 * @author oostman
 * @author mridang
 */
export function shopifyAddToCart(variantId: string, quantity = 1) {
  const data = { quantity, id: variantId }
  return callCartEndpoint(data)
}

/**
 *
 * @param {{productId: String, skuId: String, quantity: integer}[]} products
 */
export function shopifyAddMultipleToCart(products: ProductAddToCart[] = []) {
  const items = products.map(product => ({
    quantity: product.quantity || 1,
    id: product.skuId
  }))
  return callCartEndpoint({ items })
}

/**
 * Prepares the cart items with discount plan and then invokes the shopify API to apply the discount
 * @param { Array<Object> } shopifyCartDetails
 */
export function shopifyAddToCartWithDiscount(shopifyCartDetails: object) {
  return callCartEndpoint(shopifyCartDetails)
}
